import ProjectMemberView from './ProjectMemberView';

export default ProjectMemberView;
